import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@chakra-ui/react';

// Fade-up on first scroll into view (design-system.md §8.3, "Scroll reveal"). Content is visible
// immediately when the browser lacks IntersectionObserver or the user prefers reduced motion.
const reduced = () => typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

const Reveal = ({ children, delay = 0, y = 16, ...rest }) => {
    const ref = useRef();
    const [shown, setShown] = useState(() => typeof IntersectionObserver === 'undefined' || reduced());

    useEffect(() => {
        if (shown || !ref.current) return;
        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) { setShown(true); io.disconnect(); }
        }, { rootMargin: '0px 0px -8% 0px' });
        io.observe(ref.current);
        return () => io.disconnect();
    }, [shown]);

    return (
        <Box
            ref={ref}
            opacity={shown ? 1 : 0}
            transform={shown ? 'none' : `translateY(${y}px)`}
            transition={`opacity .5s ease-out ${delay}ms, transform .5s cubic-bezier(0.33, 1, 0.68, 1) ${delay}ms`}
            {...rest}
        >{children}</Box>
    );
};

export default Reveal;
